// src/Zustand/AuthStore.js
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { clearClientPreferredOrganizationId } from "../../lib/clientActiveOrganization";

const useAuthStore = create(
  persist(
    (set) => ({
      isLoggedIn: false,
      userData: null,
      access: "User",
      login: (data) => set({ isLoggedIn: true, userData: data }),
      updateOrganizationInUserData: (organizationId, updates) =>
        set((state) => {
          if (!state.userData) return state;

          const targetId = Number(organizationId);
          const patchOrg = (org) =>
            org && Number(org.organization_id) === targetId
              ? { ...org, ...updates }
              : org;

          const currentOrg = state.userData.organization;
          const updatedOrganization =
            currentOrg && !Array.isArray(currentOrg)
              ? patchOrg(currentOrg)
              : currentOrg;

          const updatedOrganizations = Array.isArray(state.userData.organizations)
            ? state.userData.organizations.map(patchOrg)
            : state.userData.organizations;

          return {
            userData: {
              ...state.userData,
              organization: updatedOrganization,
              ...(Array.isArray(updatedOrganizations)
                ? { organizations: updatedOrganizations }
                : {}),
            },
          };
        }),
      logout: () => {
        localStorage.removeItem("token");
        clearClientPreferredOrganizationId();
        return set({ isLoggedIn: false, userData: null, access: "User" });
      },
      setAccess: (access = "User") => set({ access }),
    }),
    {
      name: "hr-auth-store",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isLoggedIn: state.isLoggedIn,
        userData: state.userData,
        access: state.access,
      }),
    }
  )
);
export default useAuthStore;
